var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminderActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / file"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 9.99967C5.83333 9.53944 6.20643 9.16634 6.66667 9.16634H13.3333C13.7936 9.16634 14.1667 9.53944 14.1667 9.99967C14.1667 10.4599 13.7936 10.833 13.3333 10.833H6.66667C6.20643 10.833 5.83333 10.4599 5.83333 9.99967Z",
    fill: "#2686C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.333C6.20643 13.333 5.83333 13.7061 5.83333 14.1663C5.83333 14.6266 6.20643 14.9997 6.66667 14.9997H13.3333C13.7936 14.9997 14.1667 14.6266 14.1667 14.1663C14.1667 13.7061 13.7936 13.333 13.3333 13.333H6.66667Z",
    fill: "#2686C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 0.833008C3.99238 0.833008 2.5 2.32539 2.5 4.16634V15.833C2.5 17.674 3.99238 19.1663 5.83333 19.1663H14.1667C16.0076 19.1663 17.5 17.674 17.5 15.833V7.57147C17.5 6.79168 17.2266 6.03657 16.7274 5.43752L13.8898 2.03239C13.2565 1.27242 12.3183 0.833008 11.3291 0.833008H5.83333ZM4.16667 4.16634C4.16667 3.24587 4.91286 2.49967 5.83333 2.49967H10.8333V4.99967C10.8333 6.84062 12.3257 8.33301 14.1667 8.33301H15.8333V15.833C15.8333 16.7535 15.0871 17.4997 14.1667 17.4997H5.83333C4.91286 17.4997 4.16667 16.7535 4.16667 15.833V4.16634ZM15.5661 6.66634C15.5299 6.61029 15.4901 6.55623 15.447 6.50449L12.6094 3.09937C12.5747 3.05772 12.5382 3.01801 12.5 2.98029V4.99967C12.5 5.92015 13.2462 6.66634 14.1667 6.66634H15.5661Z",
    fill: "#2686C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderActive);
export default __webpack_public_path__ + "static/media/reminder-active.ab88128bd3da02308fd613adcb74d002.svg";
export { ForwardRef as ReactComponent };